import { render } from "./LabeledCounter.vue?vue&type=template&id=53bd6ae0"
import script from "./LabeledCounter.vue?vue&type=script&lang=js"
export * from "./LabeledCounter.vue?vue&type=script&lang=js"

import "./LabeledCounter.vue?vue&type=style&index=0&id=53bd6ae0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__